import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useUserAuth } from "../User/UserAuthContext/UserAuthContext";
import { ROUTES } from "../config/routes";
import FeeSPop2 from "../../src/assests/FeeSticky2.webp";
import "./Home2.css";

function StickyVideoUp() {
  const { user } = useUserAuth();
  const location = useLocation();
  const [isHeroVisible, setIsHeroVisible] = useState(
    location.pathname === ROUTES.home
  );

  const uploadPath = user ? ROUTES.registerForm : ROUTES.login;
  const shouldHidePopup = location.pathname === ROUTES.home && isHeroVisible;

  useEffect(() => {
    if (location.pathname !== ROUTES.home) {
      setIsHeroVisible(false);
      return undefined;
    }

    const heroSection = document.querySelector(".image-section2");

    if (!heroSection) {
      setIsHeroVisible(false);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsHeroVisible(entry.intersectionRatio > 0.8);
      },
      { threshold: [0, 0.8] }
    );

    observer.observe(heroSection);

    return () => observer.disconnect();
  }, [location.pathname]);

  return (
    <>
      <Link to={uploadPath} className="BlikingText">
        <div className="blink">
          <p>Upload your 1 minute cricket video clip</p>
        </div>
      </Link>

      {!shouldHidePopup && (
        <Link to={uploadPath} className="popup-home">
          <div className="modal">
            <div className="modal-content">
              <img src={FeeSPop2} alt="" />
            </div>
          </div>
        </Link>
      )}
    </>
  );
}

export default StickyVideoUp;
